window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.welcomeBox = window.locales.am.welcomeBox || {};window.locales.am.welcomeBox = {...window.locales.am.welcomeBox, ...{
    "header": "እንኳን ወደ {brandNameShort}፣ {name} በደህና መጡ!",
    "contentEnjoyYourTime": "ከእኛ ጋር በማጥናት ላይ ያሉበትን ጊዜ እንደሚደሰቱ ተስፋ እናደርጋለን።",
    "contentHappyLearning": "ደስተኛ ትምህርት!"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.welcomeBox = window.locales.ar.welcomeBox || {};window.locales.ar.welcomeBox = {...window.locales.ar.welcomeBox, ...{
    "header": "مرحبًا بك في {brandNameShort}، {name}!",
    "contentEnjoyYourTime": "نأمل أن تستمتع بوقتك في الدراسة معنا.",
    "contentHappyLearning": "تعلم سعيد!"
}
};window.locales.en = window.locales.en || {};window.locales.en.welcomeBox = window.locales.en.welcomeBox || {};window.locales.en.welcomeBox = {...window.locales.en.welcomeBox, ...{
    "header": "Welcome to {brandNameShort}, {name}!",
    "contentEnjoyYourTime": "We hope you enjoy your time studying with us.",
    "contentHappyLearning": "Happy Learning!"
}
};window.locales.es = window.locales.es || {};window.locales.es.welcomeBox = window.locales.es.welcomeBox || {};window.locales.es.welcomeBox = {...window.locales.es.welcomeBox, ...{
    "header": "¡Bienvenido a {brandNameShort}, {name}!",
    "contentEnjoyYourTime": "Esperamos que disfrutes tu tiempo estudiando con nosotros.",
    "contentHappyLearning": "¡Feliz Aprendizaje!"
}
};window.locales.it = window.locales.it || {};window.locales.it.welcomeBox = window.locales.it.welcomeBox || {};window.locales.it.welcomeBox = {...window.locales.it.welcomeBox, ...{
    "header": "Benvenuto in {brandNameShort}, {name}!",
    "contentEnjoyYourTime": "Speriamo che ti piaccia il tempo trascorso a studiare con noi.",
    "contentHappyLearning": "Buon Apprendimento!"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.welcomeBox = window.locales.zh.welcomeBox || {};window.locales.zh.welcomeBox = {...window.locales.zh.welcomeBox, ...{
    "header": "欢迎来到{brandNameShort}，{name}！",
    "contentEnjoyYourTime": "我们希望您在与我们一起学习的时光中感到愉快。",
    "contentHappyLearning": "学习愉快！"
}
};